import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.scrollToBottom()
    this.observeMessages()
  }

  scrollToBottom() {
    setTimeout(() => {
      this.element.scrollTop = this.element.scrollHeight
    }, 100)
  }

  observeMessages() {
    const container = document.getElementById("messages-container")
    if (!container) return

    const observer = new MutationObserver((mutations) => {
      let shouldScroll = false

      mutations.forEach((mutation) => {
        // Check for new messages or content changes (streaming)
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          shouldScroll = true
        }
        // Check for text content changes (streaming updates)
        if (mutation.type === 'characterData') {
          shouldScroll = true
        }
      })

      if (shouldScroll) {
        this.scrollToBottom()
      }
    })

    observer.observe(container, {
      childList: true,
      subtree: true,
      characterData: true
    })
  }
}
